<template>
  <div>
    <div class="ui dividing header">
      {{ season.name }} | <small>{{ $t("courses") }}</small>
    </div>
    <div
      class="ui list"
      v-if="
        season.crs_assignation_sections &&
        season.crs_assignation_sections.length
      "
    >
      <itm-section
        :section="section"
        v-for="(section, idx) in season.crs_assignation_sections"
        :key="idx"
        @phase_confirmed="$emit('phase_confirmed')"
        @emit_show_record="emit_show_record"
        @emit_show_reprint="emit_show_reprint"
      />
    </div>
  </div>
  <!-- <generic-container :title="season.name" icon="calendar">
    <div class="content">
      <div class="description">
        <div
          class="ui list"
          v-if="
            season.crs_assignation_sections &&
            season.crs_assignation_sections.length
          "
        >
          <itm-section
            :section="section"
            v-for="(section, idx) in season.crs_assignation_sections"
            :key="idx"
            @phase_confirmed="$emit('phase_confirmed')"
            @emit_show_record="emit_show_record"
            @emit_show_reprint="emit_show_reprint"
          />
        </div>
        <div class="ui error message" v-else>
          <div class="content">
            <div class="header">
              {{ $t("no section course assigned") }}
            </div>
            <p>
              {{
                $t("you dont have any sections course assigned on this season")
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </generic-container> -->
</template>

<script>
import Section from "./Section";
// import GenericContainer from "@/components/GenericContainer";

export default {
  name: "",
  props: { season: Object },
  components: {
    "itm-section": Section,
    // GenericContainer,
  },
  methods: {
    emit_show_record(section) {
      this.$emit("emit_show_record", section);
    },
    emit_show_reprint(record) {
      this.$emit("emit_show_reprint", record);
    },
  },
};
</script>
